import usePSLList from '@/redux/hooks/usePSLList';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const PSLSelector = ({
  name = 'psl',
  label,
  editMode = true,
  options,
  additionalOptions,
  placeholder = 'Select PSL',
  ...rest
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const dataOptions = usePSLList();

  return (
    <FormSelectBox
      name={name}
      label={label || t('translation:getQuote.shippingTermsSearch.psl.label')}
      editMode={editMode}
      placeholder={placeholder}
      options={options || [...dataOptions, ...(Array.isArray(additionalOptions) ? additionalOptions : [])]}
      {...rest}
    />
  );
};

export default PSLSelector;
